import React from 'react';
import {Box} from '../../../styled';
import EntityIcon from '../../../components/EntityIcon/EntityIcon';
import JiraIssueIcon from '../platforms/Jira/JiraIssueIcon';
import JiraStatus from '../platforms/Jira/JiraStatus';
import {ReactComponent as AvatarIcon} from '../../../../images/avatar-icon.svg';
import * as Styled from '../ResultItemStyles';
import JiraDueDate from '../platforms/Jira/JiraDueDate';

export const JiraRelatedSnip = ({ data }: any) => {
  return (
    <Box mb={1}>
      <EntityIcon entityName={data.pl} size={'small'} />
      <span> </span>
      <a
        href={data.issue_url}
        target="jira"
        style={{ textDecoration: 'underline', color: 'rgba(0, 57, 187, 1)' }}
      >
        <span>{data.issue_key}: </span>
        <span>{data.summary}</span>
      </a>
    </Box>
  )
}

export const JiraRelatedDetails = ({ data }: any) => {
  const { issuetype, issue_key, summary, issue_url, status, assignee, priority, duedate } = data;
  const issueStatus = [
    <JiraIssueIcon type={issuetype.name} data={issuetype} hideName />,
    priority ? (
      <span>
        {priority.iconUrl && <img height="18" width="18" src={priority.iconUrl} alt={'priority icon'} />}
      </span>
    ) : '',
    <Box display={'inline-flex'} justifyItems={'space-around'} alignItems={'center'}>
      {assignee ? (
        <>
          <img height="24" width="24" src={data.assignee_avatar} alt={'avatar url'} />
          <Box pl={1}>{assignee}</Box>
        </>
      ) : (
        <>
          <AvatarIcon height={24} width={24} fill={'rgba(186, 189, 190, 1)'} />
          <Box pl={1}>Unassigned</Box>
        </>
      )}
    </Box>
    ,
    status && status.name ? <JiraStatus status={status.name} /> : null,
    duedate && <JiraDueDate date={duedate} />
  ].filter(s => !!s);
  return (
    <Box mb={1} display={'flex'} alignItems={'flex-start'}>
      <EntityIcon entityName={data.pl} size={'small'} />
      <Box ml={2}>
        <a
          href={issue_url}
          target="jira"
          style={{ fontWeight: 600, textDecoration: 'underline', color: 'rgba(0, 57, 187, 1)' }}
        >
          <span>{issue_key}: </span>
          <span>{summary}</span>
        </a>
        <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'}>
          {issueStatus.map((s, i) => (
            <React.Fragment key={i}>
              {s}
              {(i < issueStatus.length - 1) && <Styled.VerticalDivider />}
            </React.Fragment>
          ))}
        </Box>
      </Box>
    </Box>
  )
}
